import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PaymentSuccess() {
  const navigate          = useNavigate();
  const { upgradePlan }   = useAuth();
  const [searchParams]    = useSearchParams();
  const [status, setStatus] = useState('Activating your plan...');
  const [done, setDone]     = useState(false);
  const [error, setError]   = useState(false);

  useEffect(() => {
    const run = async () => {
      try {
        const plan    = searchParams.get('plan');
        const gateway = searchParams.get('gateway');
        const isFree  = searchParams.get('free');

        // Free plan
        if (isFree === 'true' || plan === 'free') {
          await upgradePlan('free');
          setStatus('Your free account is ready!');
          setDone(true);
          return;
        }

        // Korapay or Paystack success — trust the gateway redirect
        // No backend verification needed for test mode
        if (plan && (gateway === 'korapay' || gateway === 'paystack')) {
          await upgradePlan(plan);
          setStatus(`Your ${plan} plan is now active!`);
          setDone(true);
          return;
        }

        // Fallback — if plan is in URL just activate it
        if (plan) {
          await upgradePlan(plan);
          setStatus(`Your ${plan} plan is now active!`);
          setDone(true);
          return;
        }

        throw new Error('Could not determine plan from payment redirect.');
      } catch (err) {
        console.error('PaymentSuccess error:', err);
        setStatus('Something went wrong activating your plan. Please contact support.');
        setError(true);
        setDone(true);
      }
    };
    run();
  }, []); // eslint-disable-line

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ fontSize:56, marginBottom:16 }}>
          {error ? '⚠️' : done ? '🎉' : '⏳'}
        </div>
        <h1 style={s.title}>
          {error ? 'Something went wrong' : done ? 'Payment Successful!' : 'Processing...'}
        </h1>
        <p style={s.text}>{status}</p>

        {done && !error && (
          <button style={s.btn} onClick={() => navigate('/onboarding')}>
            Continue to App →
          </button>
        )}
        {error && (
          <>
            <button style={s.btn} onClick={() => navigate('/plans')}>
              ← Back to Plans
            </button>
            <p style={{ fontSize:13, color:'#94a3b8', fontFamily:'sans-serif', marginTop:14 }}>
              If you were charged, please contact{' '}
              <a href="mailto:info@PilotLeadGen.com" style={{ color:'#6366f1' }}>
                info@PilotLeadGen.com
              </a>
            </p>
          </>
        )}
        {!done && (
          <div style={s.spinner} />
        )}
      </div>
    </div>
  );
}

const s = {
  page:    { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(160deg,#f8faff,#eef2ff)', padding:24, fontFamily:"'Georgia',serif" },
  card:    { width:'100%', maxWidth:500, background:'#fff', border:'1px solid #e2e8f0', borderRadius:20, padding:'48px 36px', textAlign:'center', boxShadow:'0 10px 40px rgba(0,0,0,0.08)' },
  title:   { fontSize:28, fontWeight:800, marginBottom:12, color:'#0f172a' },
  text:    { fontSize:15, lineHeight:1.7, color:'#475569', marginBottom:28, fontFamily:'sans-serif' },
  btn:     { width:'100%', padding:'15px', borderRadius:12, border:'none', background:'linear-gradient(135deg,#6366f1,#818cf8)', color:'#fff', fontWeight:700, fontSize:16, cursor:'pointer', fontFamily:'sans-serif', boxShadow:'0 4px 20px rgba(99,102,241,0.3)' },
  spinner: { width:32, height:32, border:'3px solid #e2e8f0', borderTop:'3px solid #6366f1', borderRadius:'50%', margin:'0 auto', animation:'spin 1s linear infinite' },
};